import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Play, Plus, Check, Info, Headphones } from 'lucide-react';
import Logo from './Logo';
import { useApp } from '../context/AppContext';
import { toast } from 'sonner';

export function OriginalBadge({ kind = 'ORIGINAL', className = '' }) {
  return (
    <span className={`badge-original ${className}`}>
      <Logo height={9} />
      <span>{kind}</span>
    </span>
  );
}

export function CardTitle({ item }) {
  const style = item.titleStyle || 'white-serif';
  if (style === 'gold-serif') {
    const [first, ...rest] = item.title.split(' ');
    return (
      <div className="ct">
        <div className="font-serif-cine text-gold font-bold" style={{ fontSize: rest.length ? 15 : 22, lineHeight: 1 }}>{first}</div>
        {rest.length > 0 && <div className="font-serif-cine text-gold font-bold" style={{ fontSize: 24, lineHeight: 0.95, marginTop: 1 }}>{rest.join(' ')}</div>}
      </div>
    );
  }
  return <div className={`ct ct-${style}`}>{item.title}</div>;
}

export default function ContentCard({ item, className = '', testId }) {
  const navigate = useNavigate();
  const { openDetail, toggleMyList, inMyList, isAvailable } = useApp();
  const listed = inMyList(item.id);
  const badgeKind = item.type === 'podcast' ? 'PODCAST' : item.isOriginal ? 'ORIGINAL' : null;

  const onPlay = (e) => {
    e.stopPropagation();
    if (!isAvailable(item)) { toast.error('This title is not available in your region.'); return; }
    if (item.type === 'podcast') navigate(`/podcasts/${item.id}`);
    else navigate(`/watch/${item.id}`);
  };
  const onList = (e) => {
    e.stopPropagation();
    toggleMyList(item.id);
    toast.success(listed ? `Removed "${item.title}" from My List` : `Added "${item.title}" to My List`);
  };

  return (
    <div className={`ccard group ${className}`} onClick={() => openDetail(item.id)} data-testid={testId || `card-${item.id}`} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && openDetail(item.id)}>
      <img src={item.image} alt={item.title} loading="lazy" />
      <div className="shade" />
      {badgeKind && <OriginalBadge kind={badgeKind} className="absolute left-3 top-2.5" />}
      <CardTitle item={item} />
      <div className="actions">
        <button className="icon-btn" onClick={onPlay} aria-label="Play" data-testid={`card-play-${item.id}`}>{item.type === 'podcast' ? <Headphones /> : <Play fill="currentColor" />}</button>
        <button className={`icon-btn ${listed ? 'on' : ''}`} onClick={onList} aria-label="My List" data-testid={`card-list-${item.id}`}>{listed ? <Check /> : <Plus />}</button>
        <button className="icon-btn" onClick={(e) => { e.stopPropagation(); openDetail(item.id); }} aria-label="More info"><Info /></button>
      </div>
    </div>
  );
}
